import { Flex } from 'components/styled/containers/flex'
import { Body } from 'components/styled/typography'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { keyframes, css } from 'styled-components'

const propTypes = {
  totalTime: PropTypes.number.isRequired,
  timerCount: PropTypes.number.isRequired,
  textQuestion: PropTypes.bool,
}

const defaultProps = {
  textQuestion: false,
}

export const blink = keyframes`
   0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const BlinkStyle = css`
  animation: ${blink} 1s infinite;
`

const TimerContainer = styled.div`
  position: absolute;
  display: inline-flex;
  align-items: center;
  right: ${({ theme }) => theme.space.s24};
  bottom: ${({ theme }) => theme.space.s16};
  z-index: 2;
`

const StreamTimerContainer = styled(Flex)`
  width: 100%;
  padding: ${({ theme }) => theme.space.s8};
  justify-content: ${({ $textQuestion }) =>
    $textQuestion ? 'center' : 'flex-end'};
  background-color: ${({ $textQuestion, theme }) =>
    $textQuestion ? 'transparent' : theme.color.blackO50};
`

const StyledTimerText = styled(Body)`
  color: ${props =>
    props.$timeLeft <= 10 ? props.theme.color.error110 : props.color};
  ${props => props.$timeLeft <= 10 && BlinkStyle};
`

function getMinutesAndSeconds(time) {
  const seconds = `0${Math.floor((time / 1) % 60)}`.slice(-2)
  const minutes = Math.floor((time / 1 / 60) % 60)
  return `${minutes}:${seconds}`
}

export function Timer({ timerCount, totalTime, textQuestion }) {
  const timeLeft = totalTime - timerCount
  const timerCounter = getMinutesAndSeconds(timerCount)
  const timerTotal = getMinutesAndSeconds(totalTime)

  const timerContent = (
    <StreamTimerContainer $textQuestion={textQuestion}>
      <StyledTimerText
        color={textQuestion ? 'bodyColor' : 'white'}
        mb="s0"
        $timeLeft={timeLeft}
      >
        {timerCounter}
      </StyledTimerText>
      <Body
        color={textQuestion ? 'bodyColor' : 'white'}
        mb="s0"
        ml="s4"
        mr="s4"
      >
        /
      </Body>
      <Body color={textQuestion ? 'bodyColor' : 'white'} mb="s0">
        {timerTotal}
      </Body>
    </StreamTimerContainer>
  )

  if (textQuestion) {
    return (
      <Flex mt="s20" alignItems="center" flexDirection="column">
        {timerContent}
      </Flex>
    )
  }
  return <TimerContainer>{timerContent}</TimerContainer>
}

Timer.propTypes = propTypes
Timer.defaultProps = defaultProps

export default Timer
